module.exports = ".underline{\n    width: 100%;\n}"